import React from 'react';
import { Stack } from '@mui/material';
import { useSelector } from 'react-redux';
import Endpoints from './Analysis/Endpoints';
import ServerSelector from './Analysis/ServerSelector';

export default function handler() {
  const selectedServer = useSelector((state) => state.networkUndo?.present?.selectedServer || 'http://localhost:8000');

  return (
    <Stack sx={{ p: 2 }}>
      <ServerSelector />
      <Endpoints selectedServer={selectedServer} />
    </Stack>
  );
}
